// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"e9cb51f9","168":"d374ed84","607":"f29ebf7f","702":"b83d9778","914":"402f5bc6"}[chunkId] + ".chunk.js";
};